export default {
  // ===== 充值/订单管理共享（RechargeManage + OrderLedger）=====
  'pages.billing.bizVoiceClone': '音色克隆',
  'pages.billing.bizSim': '4G 流量充值',
  'pages.billing.bizVoiceCloneQuota': '音色克隆次数包',

  'pages.billing.saved': '已保存',
  'pages.billing.saveFail': '保存失败',
  'pages.billing.deleted': '已删除',
  'pages.billing.detailLoadFail': '加载详情失败',
  'pages.billing.retryTriggered': '已触发重试',
  'pages.billing.wechatRefundStarted': '已发起微信原路退款',

  'pages.billing.colCode': '编码',
  'pages.billing.colName': '名称',
  'pages.billing.colEnabled': '启用',
  'pages.billing.colSort': '排序',
  'pages.billing.colActions': '操作',
  'pages.billing.colProvider': '提供商',
  'pages.billing.colPackageName': '套餐名',
  'pages.billing.colPlatformCode': '平台编码',
  'pages.billing.colUseTypeField': '用 type 字段',
  'pages.billing.colUserPrice': '用户价(元)',
  'pages.billing.colCostPrice': '成本价(元)',
  'pages.billing.colOrderNo': '订单号',
  'pages.billing.colType': '类型',
  'pages.billing.colBizType': '业务类型',
  'pages.billing.colUserId': '用户ID',
  'pages.billing.colDeviceId': '设备ID',
  'pages.billing.colAmount': '金额(元)',
  'pages.billing.colFee': '手续费(元)',
  'pages.billing.colStatus': '状态',
  'pages.billing.colRefundStatus': '退款状态',
  'pages.billing.colCreatedAt': '创建时间',
  'pages.billing.colCompletedAt': '完成时间',
  'pages.billing.colPayChannel': '支付渠道',

  'pages.billing.yes': '是',
  'pages.billing.no': '否',
  'pages.billing.edit': '编辑',
  'pages.billing.delete': '删除',
  'pages.billing.confirmDelete': '确定删除？',
  'pages.billing.detail': '详情',
  'pages.billing.retryRecharge': '重试充值',
  'pages.billing.wechatRefund': '微信退款',
  'pages.billing.usedNoRefund': '已消耗次数不可退',
  'pages.billing.retryConfirm': '确认对该订单再次发起物联充值？（已向平台下发过的订单不可重试）',
  'pages.billing.wechatRefundConfirm': '确认发起微信全额原路退款？退款到账时间以微信为准。',

  'pages.billing.tabProviders': '物联卡提供商',
  'pages.billing.tabPackages': '充值套餐',
  'pages.billing.tabOrders': '充值订单',
  'pages.billing.newProvider': '新建提供商',
  'pages.billing.newPackage': '新建套餐',
  'pages.billing.refresh': '刷新',
  'pages.billing.query': '查询',
  'pages.billing.filterOrderType': '订单类型',
  'pages.billing.all': '全部',
  'pages.billing.optional': '可选',
  'pages.billing.orderNoFuzzy': '订单号（模糊）',

  'pages.billing.statusPending': '待支付',
  'pages.billing.statusPaid': '已支付',
  'pages.billing.statusRecharging': '充值中',
  'pages.billing.statusDone': '已完成',
  'pages.billing.statusFailed': '失败',
  'pages.billing.statusCancelled': '已取消',

  'pages.billing.rechargeManageTitle': '流量卡充值管理',
  'pages.billing.orderLedgerTitle': '订单台账',
  'pages.billing.editProvider': '编辑提供商',
  'pages.billing.uniqueCode': '唯一编码',
  'pages.billing.required': '必填',
  'pages.billing.requiredSelect': '必选',
  'pages.billing.providerCodePlaceholder': '如 wanweilOT，需与服务端 recharge.sim_platforms 配置键一致',
  'pages.billing.editPackage': '编辑套餐',
  'pages.billing.selectProvider': '选择提供商',
  'pages.billing.packageName': '套餐名称',
  'pages.billing.platformPackageCode': '平台套餐编码 (pcode/type)',
  'pages.billing.platformPackageCodePlaceholder': '一级代理平台套餐编码',
  'pages.billing.useTypeFieldLabel': '使用 type 字段（否则用 pcode）',
  'pages.billing.userPriceYuan': '用户售价(元)',
  'pages.billing.platformCostYuan': '平台成本价(元)',
  'pages.billing.onShelf': '上架',

  'pages.billing.orderDetailTitle': '订单详情',
  'pages.billing.loading': '加载中…',
  'pages.billing.secOrderPay': '订单与支付',
  'pages.billing.secDevice': '设备',
  'pages.billing.secSimCardSnapshot': '物理网卡（快照）',
  'pages.billing.secPackage': '套餐',
  'pages.billing.dWechatTradeNo': '微信交易号',
  'pages.billing.dPaidAt': '支付时间',
  'pages.billing.dFailedReason': '失败原因',
  'pages.billing.dRechargeError': '物联充值错误',
  'pages.billing.dRefundedAt': '退款时间',
  'pages.billing.dQuotaTotal': '购买次数',
  'pages.billing.dQuotaUsed': '已消耗次数',
  'pages.billing.dRemaining': '剩余次数',
  'pages.billing.dDevId': '设备 ID',
  'pages.billing.dDevName': '设备名称',
  'pages.billing.dIotSCode': '物联卡号',
  'pages.billing.dPlatformOrder': '平台订单号',
  'pages.billing.dPkgId': '套餐 ID',
  'pages.billing.dPrice': '售价(元)',
  'pages.billing.total': '共 {count} 条',

  // ===== SimRecharge（Web 控制台）本次新建 =====
  'pages.simRecharge.notice.heading': '购前须知',
  'pages.simRecharge.notice.sec1Title': '一、免责与风险提示',
  'pages.simRecharge.notice.sec1Body':
    '您理解并同意：4G 流量套餐充值依赖设备、运营商及第三方平台系统，可能受网络波动、资费策略、维护窗口、卡状态等因素影响。「{platform}」将在合理范围内为您办理充值，但不对特定到账时刻、平台展示与运营商侧数据偶发不一致、以及不可抗力造成的损失承担超出法律法规要求以外的责任。请付款前再次核对所选<b>设备与 ICCID、套餐名称与金额</b>，确认无误后再支付。',
  'pages.simRecharge.notice.sec2Title': '二、退款规则',
  'pages.simRecharge.notice.sec2p1':
    '（1）<b>充值失败</b>：若支付后订单最终判定为充值失败，已支付款项将按<b>微信支付原路退回</b>。实际路径以微信及订单状态为准：可能由系统自动完成退款，也可能需要您在「我的订单」中对失败单<b>手动申请</b>原路退款；请留意订单状态与微信账单。',
  'pages.simRecharge.notice.sec2p2':
    '（2）<b>充值成功</b>：当订单显示充值已完成且套餐已下发或已生效后，本服务属于已履行的数字化/通信类消费，<b>不支持退款</b>，请在下单前谨慎选择。',
  'pages.simRecharge.notice.sec3Title': '三、其他',
  'pages.simRecharge.notice.sec3Body':
    '本须知作为《用户协议》的补充；如有不一致，以《用户协议》及页面公示为准。如有疑问，请通过应用内公示的客服渠道联系。',

  'pages.simRecharge.platformDefault': '本平台',
  'pages.simRecharge.loadPkgFail': '加载套餐失败',
  'pages.simRecharge.deviceLabel': '设备 #{id}',
  'pages.simRecharge.prefillInvalid': '链接中的设备或物理网卡无效，请在下拉框中手动选择。',
  'pages.simRecharge.done': '充值已完成',
  'pages.simRecharge.rechargeFailed': '充值失败',
  'pages.simRecharge.cancelled': '订单已取消',
  'pages.simRecharge.statusFallback': '状态 {st}',
  'pages.simRecharge.selectDevicePkg': '请选择设备与套餐',
  'pages.simRecharge.orderFail': '下单失败',
  'pages.simRecharge.noCodeUrl': '未获取到付款码，请确认服务端已开通微信 Native 支付',
  'pages.simRecharge.cancelSent': '已尝试取消待支付订单（若已支付请忽略）',
  'pages.simRecharge.loadOrdersFail': '加载订单失败',
  'pages.simRecharge.disabled': '当前环境未开启流量卡充值或微信支付，请联系管理员。',
  'pages.simRecharge.scanHint': '请使用本人微信扫描付款码完成支付；支付成功后页面将自动刷新结果。',
  'pages.simRecharge.prefillBanner': '已从设备管理带入：{device}，物理网卡 ICCID：{iccid}',
  'pages.simRecharge.tab.recharge': '去充值',
  'pages.simRecharge.tab.orders': '我的订单',
  'pages.simRecharge.selectDeviceLabel': '选择设备（需已上报 ICCID）',
  'pages.simRecharge.selectDevicePlaceholder': '请选择设备',
  'pages.simRecharge.deviceFallback': '设备',
  'pages.simRecharge.selectPackageLabel': '选择套餐',
  'pages.simRecharge.selectPackagePlaceholder': '请选择套餐',
  'pages.simRecharge.selectDeviceFirst': '请先选择设备',
  'pages.simRecharge.genPayCode': '生成微信付款码',
  'pages.simRecharge.orderStatusPending': '待支付',
  'pages.simRecharge.orderStatusPaid': '已支付',
  'pages.simRecharge.orderStatusRecharging': '充值中',
  'pages.simRecharge.orderStatusDone': '已完成',
  'pages.simRecharge.orderStatusFailed': '充值失败',
  'pages.simRecharge.orderStatusCancelled': '已取消',
  'pages.simRecharge.filterStatus': '订单状态',
  'pages.simRecharge.filterStatusAll': '全部',
  'pages.simRecharge.filterOrderNo': '订单号（模糊）',
  'pages.simRecharge.filterQuery': '查询',
  'pages.simRecharge.noticeModalTitle': '4G 流量充值 — 购前须知',
  'pages.simRecharge.noticeAgree': '我已阅读并理解上述须知（含免责与退款规则）',
  'pages.simRecharge.agreeAndGenPayCode': '同意并生成付款码',
  'pages.simRecharge.wechatScanTitle': '微信扫码支付',
  'pages.simRecharge.closeAndCancel': '关闭并取消待支付',
  'pages.simRecharge.payOrderInfo': '订单 {no}，应付 ¥{amount}',
};
